import './StatCard.css'

import type { ReactNode } from 'react'
import { Link } from 'react-router'

import { cx } from '../utilities/cx'

export type StatCardProps = {
  className?: string
  label: string
  value: ReactNode
  hint?: string
  href?: string
  onClick?: () => void
}

export const StatCard = (props: StatCardProps) => {
  const { className, label, value, hint, href, onClick } = props

  const body = (
    <>
      <span className="stat-card__label">{label}</span>
      <span className="stat-card__value">{value}</span>
      {hint && <span className="stat-card__hint">{hint}</span>}
    </>
  )

  if (href) {
    return (
      <Link to={href} className={cx('stat-card', 'stat-card--interactive', className)}>
        {body}
      </Link>
    )
  }

  if (onClick) {
    return (
      <button
        type="button"
        className={cx('stat-card', 'stat-card--interactive', 'stat-card--button', className)}
        onClick={onClick}
      >
        {body}
      </button>
    )
  }

  return <div className={cx('stat-card', className)}>{body}</div>
}
